import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, DatePicker } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import { maskDate } from "../utils/Masker";
import axios from 'axios';
import moment from "moment-timezone";
import numeral from "numeral";
import PessoaFrame from './PessoaFrame';
import TipoDocFrame from './TipoDocFrame';
import CondPagtoFrame from './CondPagtoFrame';
import VendaItemForm from './VendaItemForm';
import ModalPadraoForm from './ModalPadraoForm';
import TituloParcelaForm from './TituloParcelaForm';
import { getUsuario } from "../utils/LoginManager";

const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;
const ButtonGroup = Button.Group;


export default class CompraForm extends Component {
  state = {
    registro: {
      com_idf: 0,
      com_numero: '',
      nfe_chave: '',
      com_dt_compra: moment().format('DD/MM/YYYY'),
      com_obs: '',
      com_qtde_itens: 0,
      com_vlr_itens: 0,
      com_vlr_acres: 0,
      com_vlr_desc: 0,
      com_vlr_total: 0,
      com_pessoa: { key: '0' },
      com_tipo_doc: { key: '0' },
      com_cond_pagto: { key: '0' },
    },
    modalProdutoVisible: false,
    modalParcelaVisible: false,
    modalListaVisible: false,
    tipoTela: 'COM',

    carregandoForm: false,
    editando: false,
    visualizando: false,
    caixaFechado: false,

    activeKey: "dados",

    listaProdutos: [],
    listaParcelas: [],
    vlrTotalParc: 0,
    vlrDifParc: 0,
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      let caixaFechado = false;
      if (this.props.registroSelecionado.listaParcelas) {
        for (var x in this.props.registroSelecionado.listaParcelas) {
          if (this.props.registroSelecionado.listaParcelas[x].cx_situacao === 0) {
            caixaFechado = true;
          }
        };
      }
      const dados = {
        ...this.props.registroSelecionado.dados,
        nfe_chave: this.props.registroSelecionado.dados.nfe_chave
          || this.props.registroSelecionado.dados.com_nfe_chave
          || '',
      };

      this.setState({
        registro: dados,
        com_pessoa: dados.com_pessoa,
        com_tipo_doc: dados.com_tipo_doc,
        com_cond_pagto: dados.com_cond_pagto,
        listaProdutos: this.props.registroSelecionado.listaProdutos ? this.props.registroSelecionado.listaProdutos : [],
        listaParcelas: this.props.registroSelecionado.listaParcelas ? this.props.registroSelecionado.listaParcelas : [],
        caixaFechado,
        visualizando: this.props.registroSelecionado.dados.visualizando,
        editando: false,
        activeKey: "dados",
      }, () => {
        this.calculoTotalPedido(this.props.registroSelecionado.listaProdutos ? this.props.registroSelecionado.listaProdutos : []);
      });

      if (this.props.registroSelecionado.dados.com_idf) {
        this.setState({
          editando: true,
          activeKey: "dados",
        });
      }
    }
  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
  }

  onOK = () => {

    if ((!this.state.registro.com_dt_compra) || (!moment(this.state.registro.com_dt_compra, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data Válida' });
      return;
    }
    if ((!this.state.registro.com_pessoa) || (this.state.registro.com_pessoa.key === '0') || (this.state.registro.com_pessoa.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Fornecedor', });
      return;
    }
    if ((!this.state.listaProdutos) || (this.state.listaProdutos.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Inclua algum produto da compra' });
      return;
    }
    if ((this.state.listaParcelas) && (this.state.listaParcelas.length > 0)) {
      let vlrTotalParc = 0
      for (var x in this.state.listaParcelas) {
        vlrTotalParc = vlrTotalParc + parseFloat(this.state.listaParcelas[x].tparc_valor);
      };
      let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.com_vlr_total)).toFixed(2));
      if (vlrDifParc !== 0) {
        Modal.warning({ title: 'Aviso!', content: 'O Valor Total do Título não Confere com o Valor Total das parcelas', });
        return;
      }
    }

    const registro = {
      com_idf: this.state.registro.com_idf,
      com_dt_compra: moment(this.state.registro.com_dt_compra, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      com_numero: this.state.registro.com_numero ? this.state.registro.com_numero : '0',
      origem_importacao_nfe: this.state.registro.origem_importacao_nfe ? 1 : 0,
      nfe_chave: this.state.registro.nfe_chave || this.state.registro.com_nfe_chave || '',
      nfe_numero: this.state.registro.nfe_numero || this.state.registro.com_numero || '',
      nfe_serie: this.state.registro.nfe_serie || '',
      com_pessoa: this.state.com_pessoa.key,
      pes_nome: this.state.com_pessoa.label,
      com_tipo_doc: this.state.registro.com_tipo_doc.key,
      com_cond_pagto: this.state.registro.com_cond_pagto.key,
      com_vlr_itens: this.state.registro.com_vlr_itens,
      com_vlr_desc: this.state.registro.com_vlr_desc,
      com_vlr_acres: this.state.registro.com_vlr_acres,
      com_vlr_total: this.state.registro.com_vlr_total,
      com_obs: this.state.registro.com_obs,
      com_tipo_compra: 'C',

      listaProdutos: this.state.listaProdutos,
      listaParcelas: this.state.listaParcelas,
    };
    this.props.onSalvarClick(registro);
  };

  calculoTotalPedido = (listaProdutos) => {
    const { registro } = this.state;
    let qtdeItens = 0;
    let vlrItens = 0;
    let vlrDesc = 0;
    let vlrAcres = 0;
    let vlrTotal = 0;

    for (var x in listaProdutos) {
      qtdeItens = qtdeItens + parseFloat(listaProdutos[x].mi_qtde);
      vlrItens = vlrItens + (parseFloat(listaProdutos[x].mi_qtde) * parseFloat(listaProdutos[x].mi_vlr_unit));
      vlrDesc = vlrDesc + parseFloat(listaProdutos[x].mi_vlr_desc);
      vlrAcres = vlrAcres + parseFloat(listaProdutos[x].mi_vlr_acres);
      vlrTotal = vlrTotal + parseFloat(listaProdutos[x].mi_vlr_total);
    };

    qtdeItens = parseFloat(qtdeItens);
    vlrItens = parseFloat(vlrItens.toFixed(2));
    vlrDesc = parseFloat(vlrDesc.toFixed(2));
    vlrAcres = parseFloat(vlrAcres.toFixed(2));
    vlrTotal = parseFloat(vlrTotal.toFixed(2));

    registro.com_qtde_itens = qtdeItens;
    registro.com_vlr_itens = vlrItens;
    registro.com_vlr_desc = vlrDesc;
    registro.com_vlr_acres = vlrAcres;
    registro.com_vlr_total = vlrTotal;

    this.setState({
      registro,
    });
  }


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  onChangePessoa = event => {
    const { registro } = this.state;
    registro['com_pessoa'] = event.com_pessoa;
    this.setState(event);
  }

  onDateChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registro } = this.state;
    registro['com_dt_compra'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ com_dt_compra: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }







  // ----------------------------------------------------------------
  // PRODUTOS
  // ----------------------------------------------------------------

  onFecharModalProdutoClick = () => {
    this.setState({
      modalProdutoVisible: false,
    });
  }

  onSalvarProdutoClick = (listaProdutos) => {
    this.setState({
      modalProdutoVisible: false,
      listaProdutos,
    },
      this.calculoTotalPedido(listaProdutos)
    );
  }

  onNovoProduto = (event) => {
    this.setState({
      modalProdutoVisible: true,
      produtoSelecionado: {
        listaProdutos: this.state.listaProdutos,
        editando: false,
        tipoTela: 'COM',
        registro: {
          mi_seq: 0,
          mi_item: { key: '0' },
          prod_codigo: '',
          prod_descricao: '',
          prod_cod_barras: '',
          mi_qtde: 1,
          mi_vlr_unit: 0,
          mi_vlr_venda: 0,
          mi_vlr_venda_min: 0,
          mi_perc_desc: 0,
          mi_vlr_desc: 0,
          mi_vlr_acres: 0,
          mi_vlr_total: 0,
          mi_calc_estoque: 1,
          tipoItem: 'P',
        }
      }
    });
  }

  onEditarProdutosClick = (reg) => {
    this.setState({
      modalProdutoVisible: true,
      produtoSelecionado: {
        listaProdutos: this.state.listaProdutos,
        editando: true,
        tipoTela: 'COM',
        registro: {
          mi_item: {
            key: String(reg.mi_item) + '_' + String(reg.mi_item_tamanho) + '_' + String(reg.mi_item_cor),
            label: (reg.prod_grade ? (reg.prod_descricao + ' - ' + reg.ptam_descricao + ' - ' + reg.pcor_descricao) : reg.prod_descricao) + ' [' + reg.prod_codigo + ']' + (reg.prod_cod_barras !== '' ? ' [' + reg.prod_cod_barras + ']' : ''),
            prod_grade: reg.prod_grade,
            prod_cod_barras: reg.prod_cod_barras,
            pest_item: reg.mi_item,
            pest_tamanho: reg.mi_item_tamanho,
            pest_cor: reg.mi_item_cor,
            ptam_descricao: reg.ptam_descricao,
            pcor_descricao: reg.pcor_descricao,
          },
          mi_seq: reg.mi_seq,
          prod_codigo: reg.prod_codigo,
          prod_descricao: reg.prod_descricao,
          prod_cod_barras: reg.prod_cod_barras,
          mi_qtde: reg.mi_qtde,
          mi_vlr_unit: reg.mi_vlr_unit,
          mi_vlr_venda: reg.mi_vlr_venda ? reg.mi_vlr_venda : 0,
          mi_vlr_venda_min: reg.mi_vlr_venda_min ? reg.mi_vlr_venda_min : 0,
          mi_perc_desc: reg.mi_perc_desc,
          mi_vlr_desc: reg.mi_vlr_desc,
          mi_vlr_total: reg.mi_vlr_total,
          mi_calc_estoque: reg.mi_calc_estoque,
          tipoItem: 'P',
        }
      }
    });
  }

  onExcluirProdutosClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este produto?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaProdutos = [...this.state.listaProdutos];
        const index = listaProdutos.findIndex(registro => registro.prod_idf + '_' + registro.mi_item_tamanho + '_' + registro.mi_item_cor === reg.prod_idf + '_' + reg.mi_item_tamanho + '_' + reg.mi_item_cor);
        listaProdutos.splice(index, 1);
        this.setState({
          listaProdutos,
        },
          this.calculoTotalPedido(listaProdutos)
        );
      }
    })
  }


  renderValor = (com_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(com_vlr_total)).format('0,000.00')} </span>
    );
  };

  renderDescrProduto = (prod_descricao, registro) => {
    return (
      <span> {!registro.prod_grade ? prod_descricao : registro.prod_descricao + ' - ' + registro.ptam_descricao + ' - ' + registro.pcor_descricao} </span>
    );
  };


  renderAcoesProdutos = (registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Editar">
          <Button type="primary" onClick={() => this.onEditarProdutosClick(registro)} icon="edit" />
        </Tooltip>
        <Tooltip title="Excluir">
          <Button type="danger" onClick={() => this.onExcluirProdutosClick(registro)} icon="delete" />
        </Tooltip>
      </ButtonGroup>
    );
  };




  // ----------------------------------------------------------------
  // PARCELAS
  // ----------------------------------------------------------------

  montaParcelas = () => {
    let listaNova = [];
    if ((!this.state.registro.com_tipo_doc) || (this.state.registro.com_tipo_doc.key === '0') || (this.state.registro.com_tipo_doc.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Documento', });
      return;
    }

    if ((!this.state.registro.com_cond_pagto) || (this.state.registro.com_cond_pagto.key === '0') || (this.state.registro.com_cond_pagto.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Condição de Pagamento', });
      return;
    }

    if (parseFloat(this.state.registro.com_vlr_total) > 0) {
      const w_cc = this.state.usuario.par_cta_corrente_padrao;
      const w_cc_Desc = this.state.usuario.cc_descricao;
      const w_Qtde_Parc = parseInt(this.state.registro.com_cond_pagto.qtdeParc);
      const w_Parc_AVista = this.state.registro.com_cond_pagto.parcAVista;
      const w_Data_Emissao = moment(this.state.registro.com_dt_compra, 'DD/MM/YYYY').format('YYYY-MM-DD');
      let w_Data_Parc = moment(this.state.registro.com_dt_compra, 'DD/MM/YYYY').format('YYYY-MM-DD')
      let w_Sit = w_Qtde_Parc === 0 ? 'F' : 'A';
      let w_Valor_Parc = parseFloat(parseFloat(this.state.registro.com_vlr_total) / w_Qtde_Parc).toFixed(2);

      if (w_Parc_AVista) {
        w_Data_Parc = moment(this.state.registro.com_dt_compra, 'DD/MM/YYYY').format('YYYY-MM-DD');
        w_Sit = 'P'
      } else {
        w_Data_Parc = moment(w_Data_Emissao).subtract(-1, 'months').format('YYYY-MM-DD');
      }

      let iParc = 1;
      while (iParc <= w_Qtde_Parc) {
        if (iParc > 1) { w_Sit = 'A' };

        listaNova.push({
          tparc_parcela: iParc,
          tparc_data_parcela: w_Data_Parc,
          tparc_tipo_doc: String(this.state.registro.com_tipo_doc.key),
          tparc_conta_corrente: w_cc,
          tparc_valor: w_Valor_Parc,
          tparc_situacao: w_Sit,
          tparc_obs: '',
          td_descricao: this.state.registro.com_tipo_doc.label,
          cc_descricao: w_cc_Desc,
          situacao_parcela: w_Sit === 'A' ? 'ABERTO' : 'PAGO',
          pgto_vlr_desconto: 0,
          pgto_vlr_acrescimo: 0,
          pgto_vlr_pago: w_Sit === 'P' ? w_Valor_Parc : 0,
          pgto_vlr_restante: 0,
          pgto_data: w_Sit === 'P' ? w_Data_Parc : '',
          pgto_cta_corrente: w_cc,
        })

        w_Data_Parc = moment(w_Data_Parc).subtract(-1, 'months').format('YYYY-MM-DD');
        iParc++;
      }

      if ((listaNova) && (listaNova.length > 0)) {
        let vlrTotalParc = 0;
        for (var x in listaNova) {
          vlrTotalParc = vlrTotalParc + parseFloat(listaNova[x].tparc_valor);
        };

        if (parseFloat(vlrTotalParc) !== parseFloat(this.state.registro.com_vlr_total)) {
          let vlrDif = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.com_vlr_total)).toFixed(2));

          vlrDif = vlrDif * (-1);

          const vlr = (parseFloat(listaNova[0].tparc_valor) + parseFloat(vlrDif)).toFixed(2);

          listaNova[0].tparc_valor = vlr;
          listaNova[0].pgto_vlr_pago = listaNova[0].tparc_situacao === 'P' ? vlr : 0;
        }
      }
    }

    // console.log('listaNova: ', listaNova);

    this.setState({
      listaParcelas: listaNova,
      vlrTotalParc: 0,
      vlrDifParc: 0,
    });
  }

  calculaTotalParc = () => {
    let vlrTotalParc = 0
    for (var x in this.state.listaParcelas) {
      vlrTotalParc = vlrTotalParc + parseFloat(this.state.listaParcelas[x].tparc_valor);
    };
    let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.com_vlr_total)).toFixed(2));
    this.setState({
      vlrTotalParc,
      vlrDifParc,
    });
  }

  onFecharModalParcela = () => {
    this.setState({
      modalParcelaVisible: false,
    },
      this.calculaTotalParc()
    );
  }

  onEditarParcelaClick = registro => {
    if (((this.state.listaParcelas) && (this.state.listaParcelas.length > 0)) || (String(this.state.com_cond_pagto.key) === String(this.state.usuario.par_cond_pagto_informada))) {
      this.setState({
        modalParcelaVisible: true,
      });
    } else {
      Modal.warning({ title: 'Aviso!', content: 'Calcule as Parcelas para Editar' });
    }
  };

  excluirParcelas = () => {
    this.setState({
      listaParcelas: [],
      vlrTotalParc: 0,
      vlrDifParc: 0,
    });
  }

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  onChangeTipoDoc = event => {
    const { registro } = this.state;
    registro['com_tipo_doc'] = event.com_tipo_doc;
    this.state.listaParcelas = [];
    this.setState(event);
  }

  onChangeCondPagto = event => {
    const { registro } = this.state;
    registro['com_cond_pagto'] = event.com_cond_pagto;
    this.state.listaParcelas = [];
    this.setState(event);
  }


  // ----------------------------------------------------------------



  onChangeTabs = (activeKey) => {
    this.setState({ activeKey });
  }

  onCadPessoaClick = () => {
    this.setState({
      modalListaVisible: true,
      tipoTela: 'pessoas'
    });
  }

  onCadProdutosClick = () => {
    this.setState({
      modalListaVisible: true,
      tipoTela: 'produtos'
    });
  }

  onFecharModalLista = () => {
    this.setState({
      modalListaVisible: false,
      tipoTela: ''
    });
  }







  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------



  render() {
    const { onCancelarClick, carregando, visivel } = this.props;

    const { carregandoForm, listaProdutos, listaParcelas, produtoSelecionado,
      vlrDifParc, vlrTotalParc, caixaFechado, modalListaVisible, modalParcelaVisible, modalProdutoVisible, tipoTela } = this.state;

    const { com_idf, com_numero, nfe_chave, com_dt_compra, com_pessoa, com_obs, com_cond_pagto, com_tipo_doc,
      com_qtde_itens, com_vlr_total } = this.state.registro;

    // console.log('CompraForm.this.state: ', this.state);

    return (
      <Modal
        title={com_idf ? (this.state.visualizando ? "Compra" : "Edição de Compra") : "Inclusão de Compra"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >
        <ModalPadraoForm
          visivel={modalListaVisible}
          telaModal={tipoTela}
          valorTotal={0}
          onFecharClick={this.onFecharModalLista}
        />

        <VendaItemForm
          visivel={modalProdutoVisible}
          onSalvarProdutoClick={this.onSalvarProdutoClick}
          onFecharModalProdutoClick={this.onFecharModalProdutoClick}
          produtoSelecionado={produtoSelecionado}
          tipoTela={tipoTela}
        />

        <TituloParcelaForm
          visivel={modalParcelaVisible}
          onFecharClick={this.onFecharModalParcela}
          listaParcelas={listaParcelas}
          valor_Total={com_vlr_total}
          condPagto={com_cond_pagto}
        />

        <div>
          <Tabs
            type="card"
            activeKey={this.state.activeKey}
            onChange={this.onChangeTabs}
          >
            <TabPane tab="Dados Principais" key="dados">
              <div style={{ height: 350 }}>
                <Form>
                  <Row>
                    <div className="div-subTitulo">
                      <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 17 }}>
                        Dados da Compra
                      </span>
                    </div>

                    <Col xs={24} sm={6} className="camposEspacoDireita">
                      <span>Numero</span>
                      <InputForm
                        id="com_numero"
                        ref="com_numero"
                        maxLength={9}
                        onChange={this.onChange}
                        value={com_numero}
                        readOnly
                      />
                    </Col>

                    <Col xs={24} sm={6} style={{ marginTop: 3 }} className="camposEspacoDireita">
                      <span>Data Compra *</span>
                      <DatePicker
                        onChange={this.onDateChange}
                        format="DD/MM/YYYY"
                        showToday={true}
                        allowClear={false}
                        value={moment(com_dt_compra, "DD/MM/YYYY", true)}
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col xs={24} sm={11}>
                      <PessoaFrame
                        label="Fornecedor *"
                        id="com_pessoa"
                        value={com_pessoa}
                        tipo="F"
                        width={"100%"}
                        onChange={this.onChangePessoa}
                        disabled={caixaFechado}
                        descricaoPrimeiroItem="Selecione um Fornecedor"
                      />
                    </Col>
                    <Col xs={24} sm={1} style={{ marginTop: 24 }}>
                      <Tooltip title="Cadastro de Fornecedores" placement="topLeft">
                        <Button
                          type="dashed"
                          icon="plus"
                          htmlType="button"
                          onClick={() => this.onCadPessoaClick()}
                        />
                      </Tooltip>
                    </Col>

                    <Col xs={24} style={{ marginTop: 10, marginBottom: 10 }}>
                      <span>Chave NF-e</span>
                      <InputForm
                        id="nfe_chave"
                        ref="nfe_chave"
                        maxLength={44}
                        onChange={this.onChange}
                        value={nfe_chave || ''}
                        readOnly
                      />
                    </Col>

                    <Col xs={24} sm={6} style={{ paddingRight: 20 }}>
                      <span>Quantidade Produtos</span>
                      <InputForm
                        type="number"
                        id="com_qtde_itens"
                        ref="com_qtde_itens"
                        value={com_qtde_itens}
                        decimalScale={0}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{ paddingRight: 20 }}>
                      <span>Valor Total</span>
                      <InputForm
                        type="number"
                        id="com_vlr_total"
                        ref="com_vlr_total"
                        value={com_vlr_total}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={24} sm={12}>
                      <span>OBS</span>
                      <InputForm
                        id="com_obs"
                        ref="com_obs"
                        value={com_obs}
                        maxLength={200}
                        onChange={this.onChange}
                        validator={value => Boolean(value)}
                      />
                    </Col>
                  </Row>

                </Form>
              </div>
            </TabPane>


            <TabPane tab="Lista dos Produtos" key="produtos">
              <div style={{ height: 350 }}>
                <Row>
                  <Col xs={24} style={{ marginTop: -60 }}>
                    <Button
                      type="primary"
                      htmlType="button"
                      onClick={this.onNovoProduto}
                      icon="plus"
                      className="btn-primary"
                    > Novo Produto
                    </Button>
                  </Col>
                </Row>
                <Table
                  loading={{
                    spinning: carregandoForm,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaProdutos}
                  rowKey={(listaProdutos => listaProdutos.mi_item + '_' + listaProdutos.mi_item_tamanho + '_' + listaProdutos.mi_item_cor)}
                >
                  <Column
                    key="prod_codigo"
                    dataIndex="prod_codigo"
                    title="Código"
                    width={60}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="prod_descricao"
                    dataIndex="prod_descricao"
                    title="Descrição"
                    width={200}
                    align="left"
                    className="listaCadastro"
                    render={this.renderDescrProduto}
                  />
                  <Column
                    key="mi_qtde"
                    dataIndex="mi_qtde"
                    title="Qtde"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_unit"
                    dataIndex="mi_vlr_unit"
                    title="Vlr Unit"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_desc"
                    dataIndex="mi_vlr_desc"
                    title="Vlr Desc"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_total"
                    dataIndex="mi_vlr_total"
                    title="Vlr Total"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  {this.state.visualizando || caixaFechado ? null : (
                    <Column
                      key="acoes"
                      title=""
                      render={this.renderAcoesProdutos}
                      width={70}
                      align="center"
                      className="listaCadastro"
                    />
                  )}
                </Table>
              </div>
            </TabPane>



            <TabPane tab="Forma Pagamento" key="formaPagto">
              <div style={{ height: 350 }}>
                <Row>
                  {this.state.visualizando || caixaFechado ? null : (
                    <Row>
                      <Col xs={24} sm={10} style={{ marginTop: -5 }} className="camposEspacoDireita">
                        <TipoDocFrame
                          label="Tipo Documento"
                          id="com_tipo_doc"
                          value={com_tipo_doc}
                          width={"100%"}
                          onChange={this.onChangeTipoDoc}
                          descricaoPrimeiroItem="Informe o Tipo de Documento"
                        />
                      </Col>
                      <Col xs={24} sm={10} style={{ marginTop: -5 }}>
                        <CondPagtoFrame
                          label="Condição de Pagamento"
                          id="com_cond_pagto"
                          value={com_cond_pagto}
                          width={"100%"}
                          onChange={this.onChangeCondPagto}
                          descricaoPrimeiroItem="Informe a Condição de Pagamento"
                        />
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 14, marginLeft: 10 }}>
                        <Tooltip title="Calcular Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.montaParcelas}
                            className="btn-primary"
                            icon="calculator"
                          />
                        </Tooltip>
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 14, marginLeft: 10 }}>
                        <Tooltip title="Editar Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.onEditarParcelaClick}
                            className="btn-primary"
                            icon="edit"
                          />
                        </Tooltip>
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 14, marginLeft: 10 }}>
                        <Tooltip title="Excluir Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.excluirParcelas}
                            className="btn-primary"
                            icon="close"
                          />
                        </Tooltip>
                      </Col>
                    </Row>
                  )}

                  {vlrDifParc === 0 ? null : (
                    <Row style={{ marginLeft: 30, marginTop: 10, marginBottom: 10, }}>
                      <Col xs={24}>
                        <Col xs={24} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Valor Total: </span>
                          <span>{this.renderValor(com_vlr_total)}</span>
                        </Col>
                        <Col xs={24} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Valor Parcelas: </span>
                          <span>{this.renderValor(vlrTotalParc)}</span>
                        </Col>
                        <Col xs={24} sm={6}>
                          <span style={{ color: "red", fontWeight: "bold" }}>Valor Diferença: </span>
                          <span>{this.renderValor(vlrDifParc)}</span>
                        </Col>
                      </Col>
                    </Row>
                  )}

                  <div>
                    <Table
                      loading={{
                        spinning: carregandoForm,
                        tip: 'Carregando. Aguarde...',
                        size: "large"
                      }}
                      dataSource={listaParcelas}
                      pagination={false}
                      rowKey={(listaParcelas => listaParcelas.tparc_parcela)}
                    >
                      <Column
                        key="tparc_parcela"
                        dataIndex="tparc_parcela"
                        title="Parcela"
                        width={60}
                        align="center"
                        className="listaCadastro"
                      />
                      <Column
                        key="tparc_data_parcela"
                        dataIndex="tparc_data_parcela"
                        title="Data Venc"
                        width={80}
                        align="center"
                        className="listaCadastro"
                        render={this.renderData}
                      />
                      <Column
                        key="tparc_valor"
                        dataIndex="tparc_valor"
                        title="Valor Parc"
                        render={this.renderValor}
                        width={80}
                        align="right"
                        className="listaCadastro"
                      />
                      <Column
                        key="situacao_parcela"
                        dataIndex="situacao_parcela"
                        title="Situação"
                        width={80}
                        align="center"
                        className="listaCadastro"
                      />
                      <Column
                        key="td_descricao"
                        dataIndex="td_descricao"
                        title="Tipo Documento"
                        width={300}
                        align="left"
                        className="listaCadastro"
                      />
                    </Table>
                  </div>
                </Row>

              </div>
            </TabPane>

          </Tabs>
        </div>

        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar || caixaFechado ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar
                  </Button>
                )}
                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/CompraForm.js